// extracted by mini-css-extract-plugin
export var closeButton = "_52-0";